const togglerCls = "_rstruxqeq";
const overlayCls = "_rsoqe2d5c";
const definitionCls = "_rsdgitepz";
const closeBtnCls = "_rsc13n6byj";
const loadingEllipsisCls = "_rslvf4ta1";

export { closeBtnCls, definitionCls, loadingEllipsisCls, overlayCls, togglerCls };
import "./glossary-word.styles.linaria.module.css";
//# sourceMappingURL=glossary-word.styles.js.map
